import { apiClient } from "../axios.config";
import type { CancelRequest, PaymentApproveRequest } from "../dto/request/payment.request";
import type { TournamentApplyInput } from "../../types/tournament.types";
import type { Response } from "../dto/response/common.response";
import type { BankCodeResponse, CancelResponse, PaymentInfoResponse, PaymentResponse, TournamentApplyPayInfoResponse, TournamentPayInfoResponse, TournamentPayingApplyResponse } from "../dto/response/payment.response";

const model = '/v1/pay';

// 은행 코드 목록
export async function getBankCodes(): Promise<Response<BankCodeResponse[]>> {
    const { data } = await apiClient.get(`${model}/bank-codes`);
    return data;
}

/**
 * Pay Service API
 * @module PayService
 * @description 결제 관련 API
 * @author DongGyun Yoo
 * @since 1.0.0
 */


// 나이스페이 인증 요청 정보
export async function payRequest({id, type, resveNum}: {id: string | number; type: "tournament" | "resve"; resveNum: number;}): Promise<Response<{nicePayRequest: PaymentResponse}>> {
    const { data } = await apiClient.get(`${model}/nice-request/goods/type/${type}/id/${id}`, { params: { resveNum: resveNum} });
    return data;
}

export async function paySendAndApprove(form: PaymentApproveRequest): Promise<Response> {
    const { data } = await apiClient.post(`${model}/nice-request/send-auth-response-and-pay-approve`, form);
    return data;
}

// 결제 결과 조회
export async function payInfo(id: string | number): Promise<Response<PaymentInfoResponse>> {
    const { data } = await apiClient.get(`${model}/payment/${id}/info`);
    return data;
}

// 예약 취소 시 취소금 조회
export async function payCancel(form: CancelRequest): Promise<Response<CancelResponse>> {
    const { data } = await apiClient.get(`${model}/golf-park/${form.golfparkCode}/resve/${form.resveId}/cancel-info`);
    return data;
}

// 예약 취소
export async function putPayCancel(form: CancelRequest): Promise<Response> {
    const { data } = await apiClient.put(`${model}/golf-park/${form.golfparkCode}/resve/${form.resveId}/cancel`);
    return data;
}

// 대회 결제 결과 조회
export async function tournamentPayInfo(id: string | number): Promise<Response<TournamentPayInfoResponse>> {
    const { data } = await apiClient.get(`${model}/tournament-payment/${id}/info`);
    return data;
}

// 대회 접수 + 결제 요청 (온라인 결제: NICEPAY 요청 파라미터 반환)
export async function tournamentPayingApply(
    tournamentId: string | number,
    form: TournamentApplyInput,
    files: File[],
): Promise<Response<TournamentPayingApplyResponse>> {
    const formData = new FormData();
    Array.from(files).forEach((file) => formData.append("fileList", file));
    formData.append(
        "data",
        new Blob([JSON.stringify(form)], { type: "application/json" }),
    );

    const { data } = await apiClient.post(
        `${model}/tournament/${tournamentId}/paying-apply`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        },
    );
    return data;
}

// 대회 신청 결제/접수 결과 조회 (무통장입금 등)
export async function tournamentApplyPayInfo(applyId: string | number): Promise<Response<TournamentApplyPayInfoResponse>> {
    const { data } = await apiClient.get(`${model}/tournament/apply/${applyId}/info`);
    return data;
}

// 대회 결제 취소 (가상계좌/온라인 결제)
export async function putTournamentPayCancel(
    applyId: string | number,
    body?: {
        cancelReason: string;
        // 결제완료 후 가상계좌 환불 시 환불 계좌 정보
        refundBankCode?: string;
        refundAccountNo?: string;
        refundAccountHolder?: string;
    },
): Promise<Response> {
    const { data } = await apiClient.put(`${model}/tournament/apply/${applyId}/cancel`, body);
    return data;
}